import { fromJS } from 'immutable';
export var SET_TERMINAL_TREND_CHART_DATA = 'traffic-statistic/SET_TERMINAL_TREND_CHART_DATA';
export var SET_FETCH_TERMINAL_DATA_STATUS = 'traffic-statistic/SET_FETCH_TERMINAL_DATA_STATUS';
export var SET_AREA_TREND_CHART_DATA = 'traffic-statistic/SET_AREA_TREND_CHART_DATA';
export var SET_FETCH_AREA_DATA_STATUS = 'traffic-statistic/SET_FETCH_AREA_DATA_STATUS';
export var SET_ROAD_SECTION_CHART_DATA = 'traffic-statistic/SET_ROAD_SECTION_CHART_DATA';
export var SET_FETCH_ROAD_SECTION_STATUS = 'traffic-statistic/SET_FETCH_ROAD_SECTION_STATUS';
export var SET_MAP_BOUNDS = 'traffic-statistic/SET_MAP_BOUNDS';
export var SET_HEATMAP_MARKERS = 'traffic-statistic/SET_HEATMAP_MARKERS';
export var RESET = 'traffic-statistic/RESET';
export var setTerminalTrendChartData = function setTerminalTrendChartData(data) {
  return {
    type: SET_TERMINAL_TREND_CHART_DATA,
    data: data
  };
};
export var setFetchTerminalDataStatus = function setFetchTerminalDataStatus(data) {
  return {
    type: SET_FETCH_TERMINAL_DATA_STATUS,
    data: data
  };
};
export var setAreaTrendChartData = function setAreaTrendChartData(data) {
  return {
    type: SET_AREA_TREND_CHART_DATA,
    data: data
  };
};
export var setFetchAreaDataStatus = function setFetchAreaDataStatus(data) {
  return {
    type: SET_FETCH_AREA_DATA_STATUS,
    data: data
  };
};
export var setRoadSectionChartData = function setRoadSectionChartData(data) {
  return {
    type: SET_ROAD_SECTION_CHART_DATA,
    data: data
  };
};
export var setFetchRoadSectionStatus = function setFetchRoadSectionStatus(data) {
  return {
    type: SET_FETCH_ROAD_SECTION_STATUS,
    data: data
  };
};
export var setMapBounds = function setMapBounds(data) {
  return {
    type: SET_MAP_BOUNDS,
    data: data
  };
};
export var setHeatmapMarkers = function setHeatmapMarkers(data) {
  return {
    type: SET_HEATMAP_MARKERS,
    data: data
  };
};
export var reset = function reset() {
  return {
    type: RESET
  };
};
var initialState = fromJS({
  terminalTrendChartData: {},
  fetchTerminalDataStatus: 'loading',
  areaTrendChartData: {},
  fetchAreaDataStatus: 'loading',
  roadSectionChartData: {},
  fetchRoadSectionStatus: 'loading',
  mapBounds: {},
  heatmapMarkers: []
});
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_TERMINAL_TREND_CHART_DATA:
      return state.set('terminalTrendChartData', fromJS(action.data));

    case SET_FETCH_TERMINAL_DATA_STATUS:
      return state.set('fetchTerminalDataStatus', fromJS(action.data));

    case SET_AREA_TREND_CHART_DATA:
      return state.set('areaTrendChartData', fromJS(action.data));

    case SET_FETCH_AREA_DATA_STATUS:
      return state.set('fetchAreaDataStatus', fromJS(action.data));

    case SET_ROAD_SECTION_CHART_DATA:
      return state.set('roadSectionChartData', fromJS(action.data));

    case SET_FETCH_ROAD_SECTION_STATUS:
      return state.set('fetchRoadSectionStatus', fromJS(action.data));

    case SET_MAP_BOUNDS:
      return state.set('mapBounds', fromJS(action.data));

    case SET_HEATMAP_MARKERS:
      return state.set('heatmapMarkers', fromJS(action.data));

    case RESET:
      return initialState;

    default:
      return state;
  }
}